// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blocking-event-free-busy{z-index:3 !important}.free-busy-block{opacity:.7 !important}", ""]);
// Exports
module.exports = exports;
